import React from "react";

import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";

// Schicht 2 (Auftrag 8, R2): Warum ist das gelb / offen / gesperrt? Der Text
// ist der `grund` / die `klaerung` aus der Backend-Antwort -- nie ein zweiter,
// danebenstehender Satz aus dem Register. Der veraltete genau dann, wenn
// jemand bewerte() ändert.
//
// Fehlt der Grund, steht „kein Grund geliefert" -- nicht nichts. Die Hilfe
// soll die Lücke zeigen, nicht verdecken.
//
// Dieselben zwei Wege wie <Hilfe>: Maus darüber -> Tooltip, Tippen/Klick ->
// Popover (der Radix-Tooltip öffnet auf Berührung nicht, gemessen in A6).

export const KEIN_GRUND = "kein Grund geliefert";

export const grundText = (text) => {
    if (Array.isArray(text)) {
        const teile = text.map((t) => (t == null ? "" : String(t).trim())).filter(Boolean);
        return teile.length ? teile.join("\n") : null;
    }
    const t = text == null ? "" : String(text).trim();
    return t || null;
};

/**
 * Hängt den Grund an ein bestehendes Element (Ampel, Badge, Zeile). `text`
 * ist der Backend-Grund, auch als Liste mehrerer Gründe. Liegt das Element in
 * einer Zeile, die selbst auf Klick reagiert (aufklappen), öffnet ein Tippen
 * auf den Grund nur den Grund -- die Zeile bleibt, wie sie ist.
 */
export const Grund = ({ text, children, testId, className = "" }) => {
    const g = grundText(text);
    const inhalt = g
        ? <span className="whitespace-pre-line">{g}</span>
        : <span className="italic" data-kein-grund="">{KEIN_GRUND}</span>;
    return (
        <TooltipProvider delayDuration={200}>
            <Popover>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <PopoverTrigger asChild>
                            <span role="button" tabIndex={0} className={`cursor-help ${className}`.trim()}
                                  onClick={(e) => e.stopPropagation()}
                                  data-testid={testId} data-grund={g ? "ja" : "fehlt"}>
                                {children}
                            </span>
                        </PopoverTrigger>
                    </TooltipTrigger>
                    <TooltipContent className="max-w-xs font-normal">{inhalt}</TooltipContent>
                </Tooltip>
                <PopoverContent className="max-w-xs text-sm font-normal text-slate-700">{inhalt}</PopoverContent>
            </Popover>
        </TooltipProvider>
    );
};
